const attention = {
  open: '開啟提醒',
  close: '關閉提醒',
  title: '提醒',
  intro: '這裡彙集需要你注意的新線索、人工請求與回應時限。',
  unreadCount: '{count} 則未讀',
  markAll: '全部標為已讀',
  filter: { all: '全部', unread: '未讀', lead: '新線索', human: '請求人工' },
  kind: {
    lead_created: '收到新的有效線索',
    human_handoff_requested: '買家請求人工協助',
    sla_warning: '首次回應即將到期',
    sla_overdue: '回應時限已逾期',
  },
  body: {
    lead_created: '買家已授權留下聯絡方式，請進入對應線索繼續處理。',
    human_handoff_requested: '請開啟本次 Airlock 原對話，或處理已形成的關聯線索。',
    sla_warning: '這條線索仍缺少目前階段要求的人工動作。',
    sla_overdue: '鎖定的回應截止時間已過，目前仍未完成所需動作。',
  },
  target: { lead: '線索詳情', conversation: '接待原對話' },
  openTarget: '去處理',
  markRead: '標為已讀',
  read: '已讀',
  unread: '未讀',
  urgent: '優先',
  emptyTitle: '目前沒有需要注意的事項',
  emptyBody: '新的業務事件會出現在這裡，但不會因此改變線索處理狀態。',
  loading: '正在檢查新提醒…',
  failed: '暫時無法讀取提醒。',
  retry: '重新嘗試',
  newToast: '收到 {count} 則新提醒',
  boundary: '已讀狀態只屬於提醒收件匣；分配、跟進與結果仍在線索流程中完成。',
  emailBoundary: '郵件是否傳送依企業設定；郵件失敗不會遺失應用內提醒。',
  justNow: '剛剛',
  minutesAgo: '{count} 分鐘前',
  hoursAgo: '{count} 小時前',
  daysAgo: '{count} 天前',
} as const

export default attention
